import Vue from 'vue'
Vue.mixin({
  methods: {
    $Ms(text) {
      this.$message.success(text)
    },
    $Me(text) {
      this.$message.error(text)
    }
  }
})
